package com.essntl.features.proposal.ui.allproposal

import com.essntl.features.proposal.domain.model.ProposalModel

sealed interface AllProposalNavigation {
    data object AddProposal : AllProposalNavigation
    data class EditProposal(val id: String) : AllProposalNavigation
    data class Proposal(val id: String) : AllProposalNavigation
    data class ProposalHistory(
        val id: String,
        val proposalParentStatus: ProposalModel.Status?,
    ) : AllProposalNavigation

    data class EditTravelAgent(val proposal: ProposalModel) : AllProposalNavigation
    data class EditClient(val proposal: ProposalModel) : AllProposalNavigation
    data object CloseSidePanel : AllProposalNavigation
}